.card {
  display: grid;
  gap: 14px;
  padding: 18px 16px 16px;
  border: 1px solid var(--line);
  border-radius: 20px;
  background:
    radial-gradient(60% 45% at 10% 0%, color-mix(in srgb, var(--accent) 22%, transparent), transparent 70%),
    radial-gradient(55% 45% at 100% 70%, color-mix(in srgb, var(--accent-deep, var(--accent)) 14%, transparent), transparent 70%),
    var(--bg-raised);
}

.head {
  display: grid;
  justify-items: center;
  gap: 6px;
  text-align: center;
  min-width: 0;
}

.avatar {
  position: relative;
  display: grid;
  place-items: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  font-family: var(--font-display);
  font-style: italic;
  font-size: 26px;
  color: var(--on-fill);
  background: var(--fill);
  background-image: var(--fill-gradient);
  box-shadow: 0 0 0 1.5px var(--fill-ring);
}

.photo {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.avatar[data-empty] {
  color: var(--muted);
  background: var(--pill-bg);
  background-image: none;
  box-shadow: 0 0 0 1px var(--line);
}

.avatar .icon {
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 22px;
  height: 22px;
  font-size: 11px;
  box-shadow: 0 0 0 2px var(--bg-raised);
}

.name {
  max-width: 100%;
  margin-top: 4px;
  font-family: var(--font-display);
  font-style: italic;
  font-size: 21px;
  line-height: 1.2;
  overflow-wrap: anywhere;
}

.handle {
  font-size: 14px;
  color: var(--accent);
}

.muted {
  color: var(--muted);
  font-size: 13px;
  overflow-wrap: anywhere;
}

.methods {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px;
  margin: 4px 0 0;
  padding: 0;
  list-style: none;
}

.methods li {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px 3px 4px;
  border: 1px solid var(--line);
  border-radius: 999px;
  background: var(--surface);
  font-size: 12.5px;
}

.icon {
  display: inline-grid;
  place-items: center;
  flex: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-family: var(--font-body);
  font-style: normal;
  font-size: 10px;
  font-weight: 600;
  color: #fff;
  background: var(--muted);
}

.icon svg {
  width: 60%;
  height: 60%;
  fill: currentColor;
}

.icon[data-method='telegram'] {
  background: #2aabee;
}

.icon[data-method='yandex'] {
  background: #fc3f1d;
}

.icon[data-method='google'] {
  color: #4285f4;
  background: #fff;
}

.icon[data-method='vk'] {
  font-size: 8px;
  background: #0077ff;
}

.stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin: 0;
  padding-top: 10px;
  border-top: 1px solid var(--line);
  text-align: center;
}

.stats div {
  display: flex;
  flex-direction: column-reverse;
}

.stats dt {
  color: var(--muted);
  font-size: 11px;
}

.stats dd {
  margin: 0;
  font-family: var(--font-display);
  font-style: italic;
  font-size: 20px;
  line-height: 1.2;
}

.details {
  display: grid;
  grid-template-columns: 96px minmax(0, 1fr);
  gap: 6px 10px;
  margin: 0;
  font-size: 13px;
}

.details dt {
  color: var(--muted);
}

.details dd {
  margin: 0;
  min-width: 0;
  overflow-wrap: anywhere;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.action {
  padding: 6px 12px;
  border: 1px solid var(--line);
  border-radius: 999px;
  background: var(--surface);
  color: var(--text);
  font-size: 13px;
  text-decoration: none;
}

.action:hover {
  border-color: var(--accent);
}
